import moviezone from "assets/img/moviezone.png";
import gitprofiler from "assets/img/gitprofiler.png";
import forkify from "assets/img/forkify.png";
import bogo from "assets/img/bogo.png";
import tlou from "assets/img/tlou.png";
import showcase from "assets/img/showcase.png";

const getLink = (name) => `https://${name}.nicoignacio.tech`;
const getRepo = (name) => `https://github.com/theAspiringDev1/${name}`;

export default [
    {
        id: 1,
        name: "MovieZone",
        desc: "Search for your favorite TV Shows and Movies",
        tech: ["react", "styled-components","moviedb"],
        url: getLink("moviezone"),
        repo: getRepo("MovieZone"),
        img: moviezone,
    },
    {
        id: 2,
        name: "Git Profiler",
        desc: "Github Stats with Graphs",
        tech: ["react", "tailwind"],
        url: getLink("gitprofiler"),
        repo: getRepo("git-profiler"),
        img: gitprofiler,
    },
    {
        id: 3,
        name: "Project Showcase",
        desc: "Completed Challenges in Frontendmentors.io",
        tech: ["html", "css", "javascript","react", "sass","tailwind"],
        url: getLink("showcase"),
        repo: getRepo("Project-Showcase-with-React"),
        img: showcase,
    },
    {
        id: 4,
        name: "Forkify",
        desc: "Recipe app made with React",
        tech: ["react", "styled-components"],
        url: getLink("forkify"),
        repo: getRepo("forkify-react"),
        img: forkify,
    },
    {
        id: 5,
        name: "TLOU Part 2 Site",
        desc: "Clone of the official website",
        tech: ["html", "sass", "javascript"],
        url: getLink("tlou2"),
        repo: getRepo("TLOU2-Playstation-Website"),
        img: tlou,
    },
    {
        id: 6,
        name: "Bogo Apps",
        desc: "Website about children education",
        tech: ["html", "sass", "javascript"],
        url: getLink("bogoapps"),
        repo: getRepo("Bogo-Apps"),
        img: bogo,
    },
];
